export default __webpack_public_path__ + "static/media/Wallace Martins_.0b77790c.png";